import { AppSyncClientProvider } from "./AppSyncClientProvider";
export class AppSyncClientFactory {
    static createProvider() {
        return AppSyncClientFactory.client;
    }
}
AppSyncClientFactory.client = new AppSyncClientProvider();
